import { Link } from 'react-router-dom';
import './WhoAreWe.css';

const WhoAreWe = () => {
  return (
    <section className="who-are-we-section">
      <div className="who-are-we-container">
        <div className="who-are-we-content">
          <h2 className="who-are-we-title">Who We Are: UK E-Commerce Fulfilment Experts</h2>
          <p className="who-are-we-description">
            Pick Pack Pro is a trusted UK e-commerce fulfilment company and experienced 3PL provider, helping online
            retailers scale with reliable order fulfilment, Amazon FBA prep, pick and pack, secure warehousing and
            nationwide distribution. From our strategically located Milton Keynes fulfilment centre, we support Amazon,
            Shopify, TikTok Shop and direct-to-consumer brands with accurate inventory management, fast dispatch and
            technology-driven logistics — including{' '}
            <Link to="/blog/multi-channel-fulfilment-uk">multi-channel fulfilment UK</Link> — that simplify operations
            and enhance the customer experience. Prefer a checklist before you switch? Read{' '}
            <Link to="/blog/how-to-choose-a-3pl-uk-questions-checklist-red-flags">how to choose a 3PL UK</Link>.
          </p>
          <div className="who-are-we-features">
            <div className="who-are-we-feature">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M3 12L9 18L21 6" stroke="#28479e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Fast &amp; Accurate Order Fulfilment — Reliable pick, pack and dispatch services designed to keep your customers happy.</span>
            </div>
            <div className="who-are-we-feature">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M3 12L9 18L21 6" stroke="#28479e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Strategically Located in Milton Keynes — A central UK fulfilment hub offering efficient nationwide shipping and rapid carrier access.</span>
            </div>
            <div className="who-are-we-feature">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M3 12L9 18L21 6" stroke="#28479e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Real-Time Inventory Management — Live stock visibility, barcode tracking and seamless integrations with Amazon, Shopify, TikTok Shop and over 650 sales channels.</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoAreWe;
